<template>
  <div :class="['award-checkout-confirmation', additionalClasses]">
    <div class="bg-white pb-4">
      <section class="section">
        <div class="container container--narrow">
          <div class="row">
            <div class="col-12">
              <h1 class="h1 hyphens" v-text="translate('lblCheckoutConfirmationHeadline')"></h1>
              <div v-html="translate('lblCheckoutConfirmationDescription')"></div>
            </div>
          </div>
          <div class="row">
            <div class="buttons col-12">
              <a :href="listView"
                 class="mb-3 mb-m-0 button button--medium button--primary"
                 v-text="translate('btnProceed')"
              ></a>
              <button type="button"
                      class="mb-3 mb-m-0 button button--medium button--cancel"
                      v-text="translate('btnPrintCheckoutConfirmation')"
                      @click="print"
              ></button>
            </div>
          </div>
        </div>
      </section>
    </div>
    <div class="bg-grey py-4">
      <section class="section">
        <div class="container container--narrow">
          <div class="row">
            <div class="col-12 contact-data">
              <div>
                <h5 class="h4 bold" v-text="translate('lblContactDataHeadline')"></h5>
                <p>
                  <span v-text="checkoutData.contactData.company"></span><br />
                  <span v-text="salutations[checkoutData.contactData.salutation]"></span> <span v-text="checkoutData.contactData.first_name"></span> <span v-text="checkoutData.contactData.last_name"></span><br />
                  <span v-text="checkoutData.contactData.street_and_nr"></span><br />
                  <span v-text="checkoutData.contactData.zipcode"></span> <span v-text="checkoutData.contactData.city"></span><br />
                  <span v-text="countries[checkoutData.shippingData.country]"></span><br />
                  <span v-text="checkoutData.contactData.phone"></span>
                </p>
              </div>
              <div>
                <h5 class="h4 bold" v-text="translate('lblShippingAddressHeadline')"></h5>
                <p>
                  <span v-text="checkoutData.shippingData.company"></span><br />
                  <span v-text="salutations[checkoutData.contactData.salutation]"></span> <span v-text="checkoutData.contactData.first_name"></span> <span v-text="checkoutData.contactData.last_name"></span><br />
                  <span v-text="checkoutData.shippingData.street_and_nr"></span><br />
                  <span v-text="checkoutData.shippingData.zipcode"></span> <span v-text="checkoutData.contactData.city"></span><br />
                  <span v-text="countries[checkoutData.shippingData.country]"></span><br />
                  <span v-text="checkoutData.shippingData.phone"></span>
                </p>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <h5 class="h4 bold" v-text="translate('lblOrderHeadline')"></h5>
            </div>
          </div>
        </div>

        <div class="container">
          <div class="row">
            <div class="col-12">
              <div class="award-checkout-confirmation__order-details my-3">
                <div class="order-details-row order-details-row--head">
                  <div :aria-label="translate('columnHeadProductImage')" class="sr-only"></div>
                  <div :aria-label="translate('columnHeadProductDescription')" class="sr-only"></div>
                  <div class="text--right" v-text="translate('columnHeadQuantity')"></div>
                  <div class="text--right" v-text="translate('columnHeadPrice')"></div>
                </div>
                <div class="order-details-row" v-for="award in checkoutData.awards" :key="award.entity_id">
                  <div class="image"><img :src="award.teaser_image" :alt="translate('lblProductImageAlt')"></div>
                  <div>
                    <p class="title" v-text="award.teaser_title"></p>
                    <p v-if="award.teaser_text" v-text="award.teaser_text"></p>
                  </div>
                  <div class="quantity">
                    <span class="hidden-m-up" v-text="`${translate('columnHeadQuantity')}: `"></span>
                    <span v-text="parseInt(award.quantity)"></span>
                  </div>
                  <div class="price">
                    <span class="hidden-m-up" v-text="`${translate('columnHeadPrice')}: `"></span>
                    <span v-text="award.points * award.quantity"></span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AwardCheckoutConfirmation',
  props: {
    listView: String,
    additionalClasses: String,
    checkoutData: Object,
    salutations: Object,
    countries: Object,
  },
  methods: {
    print() {
      window.print();
    },
  },
};
</script>

<style lang="scss">
.award-checkout-confirmation {
  @media print {
    .button {
      display: none;
    }
  }

  &__order-details {
    .order-details-row--head {
      display: none;
    }

    .title {
      font-weight: bold;
    }

    .price {
      padding-bottom: 0;
      font-weight: bold;
    }
  }

  @media screen and (max-width: rem(767px)) {
    &__order-details {

      .title {
        margin-bottom: 0.75rem;
        font-size: 1.25rem;
        line-height: 1.2;
      }
      .price > span:last-child {
        font-size: 1.25rem;
        line-height: 1.2;
      }

      .order-details-row {
        background-color: $color-white;
        padding: rem(10px);

        .image {
          margin: rem(-10px) rem(-10px) rem(10px) rem(-10px);

          img {
            width: 100%;
          }
        }

        .quantity, .price {
          display: flex;
          background-color: $color-kws-light-gray-50;
          padding: rem(10px);
          justify-content: space-between;
          align-items: baseline;
        }
        .price {
          padding-top: 0;
        }
      }
    }
  }

  @media print, (min-width: rem(768px)) {

    .contact-data {
      display: flex;
      gap: rem(10px);

      > div {
        flex-basis: 50%;
      }
    }

    &__order-details {
      flex-basis: 100%;
      width: 100%;
      display: table;
      border-collapse: collapse;
      font-size: rem(16px);

      .order-details-row {
        display: table-row;
        border-bottom: rem(1px) solid $color-kws-gray-75;

        div {
          display: table-cell;
          padding: rem(11px) rem(20px);
          vertical-align: middle;

          p {
            margin: 0;
          }

          &.image {
            width: rem(140px);
            vertical-align: bottom;

            img {
              width: 100%;
              display: block;
            }
          }

          &.quantity {
            text-align: right;
          }
          &.price {
            text-align: right;
            font-weight: bold;
          }
        }

        &--head {
          font-weight: bold;

          div {
            padding: rem(5px) rem(20px);
          }
        }
      }
    }
  }

  @media (min-width: rem(768px)) {
    .container--narrow .row {
      width: 75%;
    }
  }
}
</style>
